export const UNITS_OF_MEASUREMENT = [
	{'humidity': '%'},
	{'pressure': 'hPa'},
	{'wind speed': 'km/h'},
];